/**
 * Size Chart Toggle Functionality
 * Handles switching between inches and centimeters views
 */

class SizeChartToggle {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation for dynamically loaded content
    document.addEventListener("click", this.handleToggleClick.bind(this));

    // Initialize scroll detection for table wrappers
    this.initScrollDetection();

    // Re-initialize when modal opens (for dynamically loaded content)
    document.addEventListener("modal:opened", () => {
      this.initScrollDetection();
    });
  }

  handleToggleClick(event) {
    const toggleBtn = event.target.closest(".size-chart-toggle-btn");
    if (!toggleBtn) return;

    const unit = toggleBtn.dataset.unit;
    const productId = toggleBtn.dataset.productId;

    if (!unit || !productId) return;

    // Update active button state
    const toggleContainer = toggleBtn.closest(".size-chart-unit-toggle");
    if (toggleContainer) {
      toggleContainer
        .querySelectorAll(".size-chart-toggle-btn")
        .forEach((btn) => {
          btn.classList.remove("active");
        });
      toggleBtn.classList.add("active");
    }

    // Show/hide the appropriate table body
    this.switchTableBody(unit, productId);
  }

  switchTableBody(unit, productId) {
    const inchesBody = document.getElementById(
      `size-chart-data-inches-${productId}`
    );
    const cmBody = document.getElementById(`size-chart-data-cm-${productId}`);

    if (inchesBody && cmBody) {
      if (unit === "inches") {
        inchesBody.style.display = "table-row-group";
        inchesBody.classList.add("active");
        cmBody.style.display = "none";
        cmBody.classList.remove("active");
      } else if (unit === "cm") {
        cmBody.style.display = "table-row-group";
        cmBody.classList.add("active");
        inchesBody.style.display = "none";
        inchesBody.classList.remove("active");
      }
    }
  }

  initScrollDetection() {
    const wrappers = document.querySelectorAll(".size-chart-table-wrapper");

    wrappers.forEach((wrapper) => {
      // Check if scrollable
      this.checkScrollable(wrapper);

      // Add scroll listener
      wrapper.addEventListener("scroll", () => {
        this.updateScrollState(wrapper);
      });

      // Re-check on window resize
      window.addEventListener("resize", () => {
        this.checkScrollable(wrapper);
      });
    });
  }

  checkScrollable(wrapper) {
    const isScrollable = wrapper.scrollWidth > wrapper.clientWidth;
    wrapper.classList.toggle("has-scroll", isScrollable);

    if (isScrollable) {
      this.updateScrollState(wrapper);
    }
  }

  updateScrollState(wrapper) {
    const isAtEnd =
      wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 5;
    wrapper.classList.toggle("scrolled-end", isAtEnd);
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new SizeChartToggle());
} else {
  new SizeChartToggle();
}
